import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var instructorListRes;
export const instructorListTodo = createAsyncThunk('instructorList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/get_instructor',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return instructorListRes = res.data
    } catch (error) {
        return instructorListRes = error.response.data
    }
})


const instructorListSlice = createSlice({
    name: 'instructorList',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(instructorListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('instructorList', state.data)
            }
        });
        builder.addCase(instructorListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default instructorListSlice.reducer; 